// drawGraph.js
export default function drawGraphOnCanvas(canvas, data) {
    if (!canvas) return;
    
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // Set margins and calculate chart dimensions
    const margin = 20;
    const chartWidth = canvas.width - margin * 2;
    const chartHeight = canvas.height - margin * 2;
    
    // Get the maximum value for scaling
    const maxValue = Math.max(...data.map(d => d.value));
    
    // Calculate bar width (with some spacing between bars)
    const numBars = data.length;
    const spacing = 10;
    const barWidth = (chartWidth - spacing * (numBars - 1)) / numBars;
    
    // Loop through the data and draw each bar
    data.forEach((d, index) => {
      const scaledHeight = (d.value / maxValue) * chartHeight;
      const x = margin + index * (barWidth + spacing);
      const y = canvas.height - margin - scaledHeight;
      
      // Draw the bar
      ctx.fillStyle = "#3498db";
      ctx.fillRect(x, y, barWidth, scaledHeight);
      
      // Draw the label below the bar
      ctx.fillStyle = "#000";
      ctx.font = "12px sans-serif";
      ctx.textAlign = "center";
      ctx.fillText(d.label, x + barWidth / 2, canvas.height - margin + 15);
    });
  }
  